import React from 'react';
import { Box, InputSelect, TextDense } from '@directsoftware/ui-kit-web-admin';
import { useSelector } from 'react-redux';
import { selectListingsSearchState } from '../../../redux/slices/listingsSearch';
import { useDetectMobile } from '../../../../shared/hooks/useDetectMobile';

const ListingsSearchSort = ({ translate, updateSearchState }) => {
  const brand = useSelector(state => state.brand);
  const searchState = useSelector(selectListingsSearchState);
  const sortOptions = [
    {
      label: translate(`cx.search.sort.default`),
      value: 'default'
    },
    {
      label: translate(`cx.search.sort.name`),
      value: 'name'
    },
    {
      label: translate(`cx.search.sort.price_asc`),
      value: 'price_asc'
    },
    {
      label: translate(`cx.search.sort.price_desc`),
      value: 'price_desc'
    }
  ];
  if (brand.organization_id === 52) {
    sortOptions.splice(0, 1);
  }
  const { isMobile, isLargeTabletOrGreater } = useDetectMobile();
  const activeSort =
    sortOptions.find(option => option.value === searchState.sort) ||
    sortOptions[0];

  return (
    <>
      {!isMobile && (
        <Box paddingLeft="xs" className="searchFilterDivider">
          <TextDense weight="semibold">
            {isLargeTabletOrGreater ? 'Sort by:' : 'Sort:'}
          </TextDense>
        </Box>
      )}
      <Box style={isMobile ? { width: '100%' } : { minWidth: 160 }}>
        <InputSelect
          options={sortOptions}
          removeBottomSpacer
          isDense
          onChange={option => {
            updateSearchState({ sort: option.value }, true);
          }}
          value={activeSort}
          inputWidth="auto"
        />
      </Box>
    </>
  );
};

export default ListingsSearchSort;
